import { FC } from 'react';
import styled from 'styled-components';
import { Skeleton } from 'ui/skeleton';
import { Divider } from 'ui/divider';
import { spacing } from 'ui/theme';

const LoadingContainer = styled.div`
  width: 50%;
`;
const SkeletonFirstRow = styled(Skeleton)`
  margin: ${spacing.half} 0;
`;
const SkeletonRow = styled.div`
  display: flex;
`;
const ContentDivider = styled(Divider)`
  margin: ${spacing.base} 0;
`;
const ColumnTextBlock = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: ${spacing.quarter};
`;

export const ContributingCampaignsSkeletonId = 'contributing-campaigns-skeleton';
export const ContributingCampaignsSkeleton: FC = () => {
  return (
    <LoadingContainer data-test={ContributingCampaignsSkeletonId}>
      <SkeletonFirstRow height={20} width={500} />
      <SkeletonRow>
        <Skeleton height={50} width={60} />
        <ColumnTextBlock>
          <Skeleton height={20} width={450} />
          <Skeleton height={16} width={450} />
        </ColumnTextBlock>
      </SkeletonRow>
      <ContentDivider />
      <SkeletonRow>
        <Skeleton height={50} width={60} />
        <ColumnTextBlock>
          <Skeleton height={20} width={450} />
          <Skeleton height={16} width={450} />
        </ColumnTextBlock>
      </SkeletonRow>
      <ContentDivider />
      <SkeletonRow>
        <Skeleton height={50} width={60} />
        <ColumnTextBlock>
          <Skeleton height={20} width={450} />
          <Skeleton height={16} width={450} />
        </ColumnTextBlock>
      </SkeletonRow>
      <ContentDivider />
      <SkeletonRow>
        <Skeleton height={50} width={60} />
        <ColumnTextBlock>
          <Skeleton height={20} width={450} />
          <Skeleton height={16} width={450} />
        </ColumnTextBlock>
      </SkeletonRow>
    </LoadingContainer>
  );
};
